import { BikeRelay40YearsPoint } from '../types';
import { API_ASSETS } from '../../../../services';
import React, { ReactNode, useEffect, useState } from 'react';
import { bikeRelay40YearsGetNow, processRelayPoints } from '../utils/bike-relay-utils';
import { format } from 'date-fns'; // Import date-fns functions

interface BikeRelay40YearsContextProps {
  relayPoints: BikeRelay40YearsPoint[];
  currentRelayPoint: BikeRelay40YearsPoint[] | null;
  totalDistance: number;
  traveledDistance: number;
  totalOffices: number;
  officesRelayed: number;
  currentDate: string;
}

export const BikeRelay40YearsContext = React.createContext<BikeRelay40YearsContextProps>({
  relayPoints: [],
  currentRelayPoint: null,
  totalDistance: 0,
  traveledDistance: 0,
  totalOffices: 0,
  officesRelayed: 0,
  currentDate: ''
});

export const BikeRelay40YearsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [relayPoints, setRelayPoints] = useState<BikeRelay40YearsPoint[]>([]);
  const [currentRelayPoint, setCurrentRelayPoint] = useState<BikeRelay40YearsPoint[]>([]);
  const [totalDistance, setTotalDistance] = useState<number>(0);
  const [traveledDistance, setTraveledDistance] = useState<number>(0);
  const [totalOffices, setTotalOffices] = useState<number>(0);
  const [officesRelayed, setOfficesRelayed] = useState<number>(0);
  const [currentDate, setCurrentDate] = useState<string>('');

  useEffect(() => {
    API_ASSETS.get<BikeRelay40YearsPoint[]>(
      'bike-relay-40-years/json/final_route_with_bike_distance.json'
    ).then((res) => {
      const now = bikeRelay40YearsGetNow();
      const {
        relayPoints,
        totalDistance,
        traveledDistance,
        officesRelayed,
        foundCurrent,
        currentRelayPoints
      } = processRelayPoints(res, now);

      setCurrentDate(format(now, 'dd-MM-yyyy'));
      setRelayPoints(relayPoints);
      setTotalDistance(totalDistance);
      setTraveledDistance(traveledDistance);
      setTotalOffices(res.length);
      setOfficesRelayed(officesRelayed);
      if (!foundCurrent) {
        setCurrentRelayPoint([res[res.length - 1]]);
      } else {
        setCurrentRelayPoint(currentRelayPoints);
      }
    });
  }, [setRelayPoints, setCurrentRelayPoint, setTotalDistance, setTraveledDistance]);

  return (
    <BikeRelay40YearsContext.Provider
      value={{
        relayPoints,
        currentRelayPoint,
        totalDistance,
        traveledDistance,
        totalOffices,
        officesRelayed,
        currentDate
      }}>
      {children}
    </BikeRelay40YearsContext.Provider>
  );
};
